module.exports = __webpack_public_path__ + "0db1a17c8a0aa9c66a385e299834ec42.pdf";